import styled from 'styled-components';

const LinkWrapper = styled.div`
  &:hover {
    span {
      text-decoration: underline;
      color: var(--color-brand-dark-alt);
    }
  }
`;

export default LinkWrapper;
